import ContactForm from "../modules/Forms/ContactForm";
ContactForm();

// Coordenadas para Vinhedo Villa Bari - Avenida Belém Velho, 3680 - Porto Alegre
var latitudeVinhedo = -30.085712;
var longitudeVinhedo = -51.137055;

// Coordenadas para o novo endereço
var latitudeNovoEndereco = -29.3351836;
var longitudeNovoEndereco = -51.5064542;

// Criando o mapa com base nas coordenadas especificadas e ajustando o zoom para 20
var map = L.map('mapa').setView([latitudeVinhedo, longitudeVinhedo], 8);

// Desabilitar o scroll do mouse
map.scrollWheelZoom.disable();

// Desabilitar o arrastar do mapa
map.dragging.disable();

// Criando uma camada de mapa
var layer = new L.TileLayer(
    "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
);
// Adicionando a camada ao mapa
map.addLayer(layer);

let customIcon = {
    iconUrl: `https://homologacao.weedev.com.br/projetos/2023/vinicola-lugares/public/site/img/Contact/pin.png`,
    iconSize: [20, 24],
    popupAnchor: [0, -67],
    setZIndex: 10,
}
let myIcon = L.icon(customIcon);

let iconOptionsVinhedo = {
    title: 'Vinhedo Villa Bari',
    draggable: false,
    icon: myIcon,
}

let iconOptionsNovoEndereco = {
    title: 'Novo Endereço',
    draggable: false,
    icon: myIcon,
}

// Criando o marcador para Vinhedo Villa Bari
let markerVinhedo = new L.Marker([latitudeVinhedo, longitudeVinhedo], iconOptionsVinhedo);
markerVinhedo.addTo(map);
markerVinhedo.bindPopup(`<p style="font-family: 'Poppins', sans-serif;">
<strong style='color:#555;' >
    Vinhedo Villa Bari
</strong>
<br>
<span style="color:gray;" >
    Avenida Belém Velho, 3680<br>
    Porto Alegre - RS<br>
    CEP: 91740-810
</span>
</p>`).closePopup(); // Feche o popup

// Criando o marcador para o novo endereço
let markerNovoEndereco = new L.Marker([latitudeNovoEndereco, longitudeNovoEndereco], iconOptionsNovoEndereco);
markerNovoEndereco.addTo(map);
markerNovoEndereco.bindPopup(`<p style="font-family: 'Poppins', sans-serif;">
<strong style='color:#555;' >
  Vinhedo do Capo
</strong>
<br>
<span style="color:gray;" >
    BR 470, 650, Linha 19<br>
    Admin - Dr. Casagrande, 466, sala 1004 <BR>
    Carlos Barbosa - RS<br>
    CEP: 95185-000
</span>
</p>`).closePopup(); // Feche o popup

var imageUrl = 'https://homologacao.weedev.com.br/projetos/2022/arcanjo/public/site/img/background-maps.svg',
    imageBounds = [
        [-65.9, -175.1],
        [84.0, 176.0]
    ];

const mapa = document.querySelector('#mapa');




